import organizationReducer from './';

export default organizationReducer;
